export enum LIST_POINT_CATEGORIES {
  "food" = "food",
  "equipment" = "equipment",
  "clothes" = "clothes",
  "medicines" = "medicines",
  "entertainment" = "entertainment",
  "other" = "other",
}

export enum LIST_POINT_UNITS {
  "piece" = "piece",
  "package" = "package",
  "kilogram" = "kilogram",
  "gram" = "gram",
  "liter" = "liter",
  "milliliter" = "milliliter",
}
